export enum OfficeEquipmentSortType {
  Id,
  Code,
  EmployeeFullName,
  GivenDateTime,
  OfficeEquipmentTypeName,
  ReturnDateTime,
  IsDeleted
}
